// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__ouomU","modalFooterButton":"ModalNotes_modalFooterButton__4xQUT"};